import { createContext, useReducer, useContext } from 'react';
import { allProjectListInitialState } from './InitialState/AllProjectList';
//import { allProjectListInitialState } from './InitialState/AllProjectList';
import { eventInitialState } from './InitialState/eventsliderInitialState';
import { globalInitialState } from './InitialState/globalInitialState';
import { oneProjectIitialState } from './InitialState/OneProjectInitialState';
import { resIitialState } from './InitialState/resInitialState';
import { subsIitialState } from './InitialState/subsInitialState';
import { userInitialState } from './InitialState/userInitialState';
import allProjectsReducer from './Reducers/AllProjectsReducer';
import contactusreducer from './Reducers/ContactUsResReduer';
import eventlistreducer from './Reducers/EventListReducer';
import globleReducer from './Reducers/GlobalReducer';
import oneProjectReducer from './Reducers/OneProjectReducer';
import sublistreducer from './Reducers/SubsReducer';
import userReducer from './Reducers/userReducer';

export const StateContext = createContext();

export const StateProvier = ({ children }) => {

    const [globalState, globalDispatch] = useReducer(globleReducer, globalInitialState);
    const [userState, userDispatch] = useReducer(userReducer, userInitialState);
    const [responseState, responseDispatch] = useReducer(contactusreducer, resIitialState);
    const [eventlistState, eventlistDispatch] = useReducer(eventlistreducer, eventInitialState);
    const [allprojetsState, allprojectsDispatch] = useReducer(allProjectsReducer, allProjectListInitialState);
    const [subslistState, subslistDispatch] = useReducer(sublistreducer, subsIitialState);
    const [oneprojectState, oneprojectDispatch] = useReducer(oneProjectReducer, oneProjectIitialState);


    return (
        <StateContext.Provider value={
            {
                globalState,
                globalDispatch,
                userState,
                userDispatch,
                responseState,
                responseDispatch,
                eventlistState,
                eventlistDispatch,
                allprojetsState,
                allprojectsDispatch,
                subslistState,
                subslistDispatch,
                oneprojectState,
                oneprojectDispatch
            }
        }>
            {children}
        </StateContext.Provider>
    );
};

export const useStateValue = () => useContext(StateContext);